import { render } from "./DiaryTab.vue?vue&type=template&id=72ce50b8&scoped=true"
import script from "./DiaryTab.vue?vue&type=script&lang=js"
export * from "./DiaryTab.vue?vue&type=script&lang=js"

import "./DiaryTab.vue?vue&type=style&index=0&id=72ce50b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ce50b8"]])

export default __exports__